export class NameFromShortcodeValueConverter {
    toView(value: string) {
        switch (value) {
            case 'DS':
                return 'DivicaSales';
            case 'CG':
                return 'Chicks Gold';
            case 'GT':
                return 'GamerTotal';
            case 'CX':
                return 'ChicksX';
            case 'AG':
                return 'Ariba Gold';
            case 'AK':
                return 'Account Kings';
            default:
                return 'UNDEFINED SHORTCODE';
        }
    }
}
